/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-06-13 00:00:00
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { withI18n } from '@shopify/react-i18n';
import { Link, Modal, TextContainer, TextStyle } from '@shopify/polaris';
import { updateLocalTenantApp } from 'actions/oauth-actions';
import { URL } from 'src/constants/links';

const MarketingCampaignPopup = props => {
  const { i18n, showConfirmedPersonalizationCampaignPopup } = props;
  const handleDismiss = () => {
    props.updateLocalTenantApp({ showConfirmedPersonalizationCampaignPopup: false });
  };

  return (
    <Modal
      open={showConfirmedPersonalizationCampaignPopup}
      onClose={handleDismiss}
      noScroll
      title={i18n.translate('AdminHTML.MarketingCampaign.RegisteredPopup.title')}
      primaryAction={{
        content: i18n.translate('AdminHTML.MarketingCampaign.RegisteredPopup.action'),
        onAction: handleDismiss
      }}>
      <Modal.Section>
        <TextContainer>
          <p>
            {i18n.translate('AdminHTML.MarketingCampaign.RegisteredPopup.content', {
              t1: (
                <TextStyle variation="strong">
                  {i18n.translate('AdminHTML.MarketingCampaign.RegisteredPopup.content_t1')}
                </TextStyle>
              ),
              t2: (
                <TextStyle variation="strong">
                  {i18n.translate('AdminHTML.MarketingCampaign.RegisteredPopup.content_t2')}
                </TextStyle>
              ),
              t3: (
                <TextStyle variation="strong">
                  {i18n.translate('AdminHTML.MarketingCampaign.RegisteredPopup.content_t3')}
                </TextStyle>
              )
            })}
            <br />

            {i18n.translate('AdminHTML.MarketingCampaign.RegisteredPopup.content02', {
              t1: (
                <Link external url={URL.Link_Personalization_Guide}>
                  {i18n.translate('AdminHTML.MarketingCampaign.RegisteredPopup.content02_t1')}
                </Link>
              )
            })}
          </p>
        </TextContainer>
      </Modal.Section>
    </Modal>
  );
};

const mapStateToProps = (state, props) => ({
  showConfirmedPersonalizationCampaignPopup: _.get(
    state.oauth,
    'tenantApp.showConfirmedPersonalizationCampaignPopup',
    false
  )
});
const mapDispatchToProps = (dispatch, ownProps) => ({
  updateLocalTenantApp: body => dispatch(updateLocalTenantApp(body))
});
export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(MarketingCampaignPopup));
